import { render, staticRenderFns } from "./permissionSection.vue?vue&type=template&id=8397f8b2&"
import script from "./permissionSection.vue?vue&type=script&lang=js&"
export * from "./permissionSection.vue?vue&type=script&lang=js&"
import style0 from "./permissionSection.vue?vue&type=style&index=0&id=8397f8b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports